import React from 'react';
import TextInputField from './TextInputField';
import { useIntl } from 'react-intl';

const CompanyName = () => {
  const { formatMessage } = useIntl();

  return (
    <TextInputField
      name="companyName"
      type="text"
      placeholder={formatMessage({
        id: 'Common.companyName',
      })}
      showClearIcon
    />
  );
};

export default CompanyName;
